import { createSelector } from 'reselect';
import { activeFacebookPageIdSelector } from './viewSelectors';
import { StoreState } from '../store-interfaces';
import { FacebookErrorModel } from '../model/FacebookErrorModel';
import { activeFacebookPageSelector } from './facebookPageSelector';

export const NOT_ELIGIBLE_STRING_CODE = '36103';

export const isNotEligibleError = (err: any) => {
  try {
    return (
      err.subCode?.toString?.() === NOT_ELIGIBLE_STRING_CODE ||
      err.sub_code?.toString?.() === NOT_ELIGIBLE_STRING_CODE
    );
  } catch (e) {
    return false;
  }
};

export const selectFacebookPageErrors = createSelector(
  [
    activeFacebookPageSelector,
    activeFacebookPageIdSelector,
    (state: StoreState) => state.errors,
  ],
  (page, pageId, errors) => errors.fbPageErrors[page?.id || pageId],
);

export const selectIsInstagramNotEligibleErrorPresent = createSelector(
  [selectFacebookPageErrors],
  (errs: FacebookErrorModel[]) => !!errs?.find(isNotEligibleError),
);
